import { useTranslation } from 'react-i18next';
import { Card, Stack, Text, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import ChangePasswordForm from '@/components/auth/ChangePasswordForm';
import { useAuth } from '@/stores/authContext';

// Вкладка «Безопасность»: инлайн-смена пароля (текущий → новый). После смены Identix отзывает старые
// токены, а бэкенд бесшовно возвращает свежую пару — подставляем без разлогина; если null — разлогин.
export default function SecurityTab() {
  const { t } = useTranslation();
  const { loginWithTokens, logout } = useAuth();

  return (
    <Card withBorder padding="lg">
      <Stack gap="md">
        <Stack gap={4}>
          <Title order={4}>{t('app.profile.security.title')}</Title>
          <Text c="gray.7" size="sm">
            {t('app.profile.security.desc')}
          </Text>
        </Stack>
        <ChangePasswordForm
          submitLabel={t('app.profile.security.submit')}
          onSuccess={(tokens) => {
            notifications.show({ color: 'lime', message: t('app.profile.security.success') });
            if (tokens) {
              loginWithTokens(tokens);
            } else {
              logout();
            }
          }}
        />
      </Stack>
    </Card>
  );
}
